var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',{staticClass:"invalid-page"},[_c('h1',[_vm._v("Page Introuvable")]),_c('p',[_vm._v(" La page que vous recherchez est introuvable. Elle pourrait avoir été supprimée, renommée, ou pourrait n’avoir jamais existé. ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }